import { render, staticRenderFns } from "./EventRequiredForm.vue?vue&type=template&id=2181f28c"
import script from "./EventRequiredForm.vue?vue&type=script&lang=js"
export * from "./EventRequiredForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports